import { Component, inject, Input, signal } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  standalone: false,
  selector: 'wr-generated-password-dialog',
  templateUrl: './generated-password-dialog.component.html',
  styleUrls: ['./generated-password-dialog.component.scss'],
})
export class GeneratedPasswordDialogComponent {
  private readonly dialogRef = inject(NbDialogRef<GeneratedPasswordDialogComponent>);
  @Input() password = '';
  @Input() userName?: string;

  readonly copied = signal(false);

  async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.password);
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    } catch {
      // Zwischenablage nicht verfügbar — Passwort kann manuell markiert werden
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
